function cov_hlrbmypfg() {
  var path = "/app/src/components/logo/index.tsx";
  var hash = "5935f8473f2e4fff8f880146d1672f518aa57f39";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5935f8473f2e4fff8f880146d1672f518aa57f39"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hlrbmypfg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_hlrbmypfg();
export { Logo } from './logo';